
<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form >
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search Concern Type  Here..."
          class="w-full border p-2 rounded-md outline-none"
          
          placeholder="Search ...." matInput (input)="applyFilter($event)"
        />
      </div>
      <div class="w-80">
        
      </div>
     
      <div class="w-60" >
        <app-primary-button routerLink="/home/add-project-closure" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add </span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>
  <div class="bg-white rounded-2xl shadow-md p-4">

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
    <td mat-cell *matCellDef="let row">{{ row.title }}</td>
  </ng-container>

  <ng-container matColumnDef="process">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Process</th>
    <td mat-cell *matCellDef="let row">{{ row.process }}</td>
  </ng-container>

  <ng-container matColumnDef="forms">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Forms</th>
    <td mat-cell *matCellDef="let row">{{ row.forms }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
    <td mat-cell *matCellDef="let row">{{ row.actions }}</td>
  </ng-container>

  <ng-container matColumnDef="reporting">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Reporting</th>
    <td mat-cell *matCellDef="let row">{{ row.reporting }}</td>
  </ng-container>

  <ng-container matColumnDef="deliverables">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Deliverables</th>
    <td mat-cell *matCellDef="let row">{{ row.deliverables }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>

</div>
